import RenderImg from '@/pages/opinion/components/RenderImg';
import React, { useEffect, useState, useRef } from 'react';
import { Card, Layout, LoadingTip } from 'tea-component';
import { connect, useIntl, useLocation } from 'umi';
import SegmentTabs from './components/segment-tabs';
import MultipleDropSelect from './components/multiple-drop-select';
import { getOpinionFilterCond, insightReport } from '@/pages/opinion/services';
import moment from 'moment';

import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import useReportBuryingPoint from '../hooks/useReportBuryingPoint';
import InsightPointFunc from '@op/operationLog/pages/insight';
import Subscribe from './components/Subscribe';
import html2pdf from 'html2pdf.js';
import './index.scss';
import { imgToBase64 } from '@/pages/opinion/utils/image';
import ContentBody from '@/pages/opinion/components/ContentBody';
import IFrameCard from '@op/components/IFrameCard';
import { DBO_U } from '@op/utils/format';
import usePageName from '@op/hooks/usePageName';
import { getMatchUrl } from '@op/utils/cdnUrl';

const { Content } = Layout;

const Insight = (props: any) => {
  const { formatMessage } = useIntl();
  const { gameInfo, wholeGameInfo, userInfo, listMenu } = props;
  const { edition_unified_id, entity_type, id_type } = gameInfo;
  const location = useLocation();
  const { max = 8, name, gameid } = location?.query || {}; // 直接获取 query 对象

  const { pageName } = usePageName({ name, listMenu });

  const [images, setImages] = useState<
    Array<{ link_url: string; image_url: string }>
  >([]);
  const [pdf, setPDF] = useState<{ pdf_url: string }>({});
  const [condLoading, setCondLoading] = useState(true);
  const [reportInsightConfig, setReportInsightConfig] = useState<any[]>([]);
  const [reportLoading, setReportLoading] = useState(true);

  const reportRef = useRef<HTMLDivElement | null>(null);

  useInitBuriedPointInfo({
    buriedPoint: InsightPointFunc(location.pathname),
    triggerPagePoint: false,
  });
  useReportBuryingPoint({ ...props });

  const getInsightReport = async (report: any) => {
    const { date } = report;
    setImages([]);
    try {
      setReportLoading(true);
      const curParmas = {
        edition_unified_id,
        date,
      };
      const res = await insightReport(curParmas);
      console.log(res);
      let images: { image_url: string; link_url: string }[] = [];
      if (res?.images?.length > 0) {
        images = res?.images;
      }
      if (res?.new_images?.length > 0) {
        images = res?.new_images;
      }

      images = images.map((item: any) => {
        const isUrl = typeof item === 'string';
        const imageUrl = isUrl ? item : item?.image_url;
        const linkUrl = isUrl ? '' : item?.link_url;
        return {
          image_url: imageUrl,
          link_url: linkUrl?.startsWith?.('/')
            ? location.origin + linkUrl
            : linkUrl,
          pdf_url: item?.pdf_url,
        };
      });

      const pdfRes = (images || [])
        .map((item: any) => {
          const isUrl = typeof item === 'string';
          const pdfUrl = isUrl ? '' : item?.pdf_url;
          const url = pdfUrl?.startsWith?.('/')
            ? location.origin + pdfUrl
            : pdfUrl;

          const cleanUrl1 = getMatchUrl(url); 
          return {
            pdf_url: cleanUrl1,
          };
        })
        .filter((item) => item?.pdf_url);
      setPDF(pdfRes[0]);

      Promise.all(
        images.map((item: { image_url: string }) =>
          imgToBase64(item.image_url),
        ),
      )
        .then((data) => {
          const newImages: Array<{ link_url: string; image_url: string }> =
            images.map((item, index) => {
              return {
                link_url: item.link_url,
                image_url: data[index] as string,
              };
            });
          setImages(newImages);
        })
        .finally(() => {
          setReportLoading(false);
        });
    } catch (error) {
      setReportLoading(false);
    }
  };

  const handleInit = (report: any) => {
    getInsightReport(report);
  };

  const handleReportChange = async (report: any) => {
    getInsightReport(report);
  };

  useEffect(() => {
    const gameId = gameInfo?.edition_unified_id;
    const urlGameId = gameid || gameId;
    if (gameId && gameId === urlGameId) {
      console.log('init', gameInfo);
      getCond();
    }

    return () => console.log('insight unload');
  }, [gameInfo]);

  async function getCond() {
    try {
      setCondLoading(true);
      const insightFilter = await getOpinionFilterCond({
        edition_unified_id: edition_unified_id,
        id_type,
        entity_type,
        request_type: ['report_insight_config'],
        un_request_type: [
          'topic_trans', // topic_trans默认会带上
        ],
      });
      setCondLoading(false);

      if (insightFilter?.report_insight_config) {
        const test = Array(20)
          .fill(1)
          .map((item, index) => ({
            date: moment().subtract(index, 'week').format('YYYY-MM-DD'),
            title: 'Insight Report' + index,
          }));

        setReportInsightConfig(insightFilter?.report_insight_config || []);
        // setReportInsightConfig(test || []); // 可以用这里的 test做测试
      }
    } catch {
      setCondLoading(false);
    }
  }

  // 下载
  const download = (activeId: string) => {
    if (pdf?.pdf_url) {
      DBO_U.open(pdf.pdf_url);
      return;
    }

    const element = document.querySelector('.dbo-report-insight-card');

    html2pdf(element, {
      filename: `${activeId}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      pagebreak: {
        mode: ['css'],
      }, // 智能分页，防止图片被截断
      enableLinks: true, // 支持文本中放链接，可点击跳转
      jsPDF: {
        unit: 'px',
        hotfixes: ['px_scaling'],
        format: [element?.scrollWidth, (element?.scrollHeight || 0) + 20],
      },
    });
  };

  return (
    <Content>
      <ContentBody
        contentHeard={
          <Content.Header
            title={pageName || formatMessage({ id: 'Newsletter' })}
            operation={
              <Subscribe
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                userInfo={userInfo}
              ></Subscribe>
            }
          />
        }
      >
        {condLoading ? (
          <LoadingTip
            loadingText=""
            style={{
              marginLeft: '48%',
              position: 'relative',
              marginTop: '30%',
            }}
          />
        ) : (
          <>
            {reportInsightConfig?.length > 0 ? (
              reportInsightConfig?.length <= max ? (
                <SegmentTabs
                  className="dbo-report-segment-tab"
                  reportInsightConfig={reportInsightConfig}
                  handleReportChange={handleReportChange}
                  handleInit={handleInit}
                  download={download}
                ></SegmentTabs>
              ) : (
                <MultipleDropSelect
                  reportInsightConfig={reportInsightConfig}
                  handleReportChange={handleReportChange}
                  handleInit={handleInit}
                ></MultipleDropSelect>
              )
            ) : null}
            <div>
              {reportLoading ? (
                <LoadingTip
                  loadingText=""
                  style={{
                    marginLeft: '48%',
                    position: 'relative',
                    marginTop: '30%',
                  }}
                />
              ) : (
                <>
                  {pdf?.pdf_url ? (
                    <IFrameCard
                      bodyStyle={{ height: 'calc(100vh - 212px)' }}
                      url={pdf.pdf_url}
                    ></IFrameCard>
                  ) : (
                    <Card ref={reportRef} className="dbo-report-insight-card">
                      {images.map(
                        (item: {
                          image_url: any;
                          link_url: string | undefined;
                        }) => {
                          return (
                            <a key={item.image_url} href={item.link_url}>
                              <RenderImg
                                box={true}
                                mode="image"
                                coverImage={item.image_url}
                              ></RenderImg>
                            </a>
                          );
                        },
                      )}
                    </Card>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </ContentBody>
    </Content>
  );
};

export default connect((state: any) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    listMenu: opinionCommon.listMenu,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(Insight);
